import React from 'react';

import {
	Drawer as ChakraDrawer,
	DrawerBody,
	DrawerCloseButton,
	DrawerContent,
	DrawerHeader,
	DrawerOverlay,
} from '@chakra-ui/react';

export const Drawer = ({ title, onClose, isOpen, size = 'xl', children, ...rest }) => {
	return (
		<ChakraDrawer onClose={onClose} isOpen={isOpen} size={size} {...rest}>
			<DrawerOverlay />
			<DrawerContent>
				<DrawerCloseButton />
				<DrawerHeader>{title}</DrawerHeader>
				<DrawerBody>{children}</DrawerBody>
			</DrawerContent>
		</ChakraDrawer>
	);
};
